/**
 * Qué cambio de plan se pone A LA VISTA en el panel.
 *
 * Hasta el 2026-10-19 la única puerta para pasar de Free a Factura+ o a
 * Business era Configuración > Plan y pago, el último apartado de la última
 * sección del menú. El propietario lo pidió visible desde el propio panel.
 *
 * ## Lo que esto NO decide
 *
 * **Qué plan está por encima de cuál.** Lo dice el servidor (`URS §105`):
 * `upgrades` para quien ya paga y sube, `contratables` para quien no tiene
 * suscripción viva. Aquí solo se elige cuál de las dos listas toca, y por eso
 * un Business puesto a mano no ve «Pasar a Business», ni un empleado ve un
 * botón de pago que no puede usar: sin OWNER, la API contesta 403 y no hay
 * lista (`OD-0014` A-10).
 *
 * **Si se puede pagar.** El pago lo sigue abriendo la API, con sus
 * comprobaciones: OWNER, price y datos de facturación (`D3-b`). El panel solo
 * decide si lo PIDE nada más pulsar o si antes enseña la pantalla del plan
 * (`abrePagoDirecto`).
 */
import type { EstadoSuscripcion, PlanDePago } from "../api/cliente";

/** Los planes que ofrecer, en el orden que los da el servidor; vacío si nada. */
export function planesQueOfrecer(estado: EstadoSuscripcion | null): readonly PlanDePago[] {
  if (estado === null) return [];
  // Las dos listas no se solapan por construcción del servidor; si algún día
  // llegaran las dos, manda subir: abrir otro Checkout con una suscripción
  // viva sería cobrar dos veces, y la API lo rechaza.
  return estado.upgrades.length > 0 ? estado.upgrades : estado.contratables;
}

/**
 * Si pulsar un plan del bloque puede ir derecho a la pantalla de pago de
 * Stripe, sin pasar por Configuración > Plan y pago (propietario, 2026-10-21:
 * «ahora hay que clicar dos veces»).
 *
 * Solo cuando la oferta es para CONTRATAR: Checkout es una pantalla de Stripe
 * donde la persona ve el precio y el IVA y confirma allí, así que pedirla al
 * pulsar no cobra nada. Subir con suscripción viva es otra cosa: Stripe cobra
 * la diferencia en el acto y no hay pantalla intermedia, de modo que ese
 * camino sigue pasando por la pantalla del plan, que lo explica antes.
 *
 * Si la API se niega —faltan los datos de facturación, por ejemplo—, el panel
 * cae a la pantalla del plan, que es la que dice qué falta.
 */
export function abrePagoDirecto(estado: EstadoSuscripcion | null): boolean {
  return estado !== null && estado.upgrades.length === 0 && estado.contratables.length > 0;
}
